import { createSelector } from 'reselect'

export const getSimilarAdsLoading = createSelector(
	(state) => state && state.ads.detail && state.ads.detail.similarAds
		&& state.ads.detail.similarAds.isLoading
	? state.ads.detail.similarAds.isLoading : null,
  (isLoading) => isLoading
)
